import React from 'react';
import {
  FiPlusCircle,
  FiImage,
  FiMapPin,
  FiDollarSign,
  FiMeh,
  FiChevronLeft,
  FiX,
  FiMenu,
  FiTrash,
  FiStar,
  FiChevronUp,
  FiChevronDown,
  FiEdit2,
  FiArrowLeft,
  FiArrowRight,
  FiMoreVertical,
  FiMoreHorizontal,
  FiSend,
  FiCopy,
  FiEyeOff,
  FiAlertTriangle,
  FiSave,
  FiUser,
  FiUpload,
} from 'react-icons/fi';
import { BiLoaderAlt } from 'react-icons/bi';
import { BsArrowsFullscreen } from 'react-icons/bs';
import { IoMdSquare } from 'react-icons/io';
import { TbInfoCircle, TbArrowsMinimize } from 'react-icons/tb';
import { FaChartBar, FaStar, FaGlobeAmericas } from 'react-icons/fa';
import { ImCalculator } from 'react-icons/im';

const DefaultIcon = () => (
  <svg
    className="mx-auto h-12 w-12 text-neutral-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    />
  </svg>
);

const helpIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.25V13C12 12.183 12.505 11.74 13.011 11.4C13.505 11.067 14 10.633 14 9.83301C14 8.72801 13.105 7.83301 12 7.83301C10.895 7.83301 10 8.72801 10 9.83301"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.999 16C11.861 16 11.749 16.112 11.75 16.25C11.75 16.388 11.862 16.5 12 16.5C12.138 16.5 12.25 16.388 12.25 16.25C12.25 16.112 12.138 16 11.999 16"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const houseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49805 9.74589L9.11334 4.07551C9.62423 3.63759 10.3781 3.63759 10.889 4.07551L17.5043 9.74589"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6707 17.5031V3.74741C16.6707 3.51719 16.484 3.33057 16.2538 3.33057H13.7528C13.5226 3.33057 13.3359 3.51719 13.3359 3.74741V5.91998"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.95312 17.5029V12.9177C7.95312 12.4572 8.32638 12.084 8.78681 12.084H11.2121C11.6725 12.084 12.0457 12.4572 12.0457 12.9177V17.5029"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.56918 8.82715V17.5027"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5043 17.5028H2.49805"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const purchaseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6668 17.5028V13.6846"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1688 17.5028V13.6846"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6688 17.5028V13.6846"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.834 17.5028H17.5034"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.834 13.6847H17.5034V12.1982L14.1687 10.8335L10.834 12.1982V13.6847Z"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1696 5.83139H13.3359"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.99805 11.6673H5.83173"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33381 14.1684H4.58225C3.43118 14.1684 2.49805 13.2353 2.49805 12.0842V5.41477C2.49805 4.862 2.71763 4.33188 3.1085 3.94101C3.49936 3.55015 4.02948 3.33057 4.58225 3.33057H14.5864C15.7375 3.33057 16.6706 4.2637 16.6706 5.41477V8.33265"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11045 10.223C7.29652 9.40907 7.29652 8.08942 8.11045 7.27549C8.92438 6.46156 10.244 6.46156 11.058 7.27549"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const buildIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8327 10.8333V7.29541"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="14.166"
      y="10.8335"
      width="3.33333"
      height="7.5"
      rx="1.66667"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0344 2.73023L14.0471 4.70341C13.8865 5.02427 13.9494 5.41187 14.2031 5.66557L15.833 7.29548L17.4649 5.66361C17.7186 5.40991 17.7814 5.02231 17.6209 4.70145L16.6346 2.73023C16.564 2.58913 16.4197 2.5 16.2619 2.5H15.407C15.2492 2.5 15.105 2.58912 15.0344 2.73023V2.73023Z"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16602 2.5L1.66602 5V6.66667H9.99935C10.4596 6.66667 10.8327 6.29357 10.8327 5.83333V3.33333C10.8327 2.8731 10.4596 2.5 9.99935 2.5H4.16602Z"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 6.6665H8.33333V16.6665C8.33333 17.587 7.58714 18.3332 6.66667 18.3332V18.3332C5.74619 18.3332 5 17.587 5 16.6665V6.6665Z"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const brrrrIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 9.375L17.5 8.125L18.75 9.375"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 10.625L2.5 11.875L1.25 10.625"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50065 12.9168V9.1001"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0007 12.9168V9.1001"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5007 12.9168V9.1001"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 12.9167H13.3327"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66602 7.61417V9.1H13.3327V7.61417L9.99935 6.25L6.66602 7.61417Z"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.68917 11.6567C2.56917 11.1233 2.5 10.57 2.5 10C2.5 5.85833 5.85833 2.5 10 2.5C12.5208 2.5 14.7417 3.75083 16.1017 5.65833"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3148 8.33984C17.4348 8.87318 17.504 9.42651 17.504 9.99651C17.504 14.1382 14.1457 17.4965 10.004 17.4965C7.48234 17.4965 5.26151 16.2457 3.90234 14.3382"
      stroke="#0C4340"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const getIcon = (icon) => {
  const icons = {
    FiPlusCircle,
    FiChevronLeft,
    FiImage,
    FiMapPin,
    FiDollarSign,
    FiMeh,
    FaChartBar,
    FiTrash,
    FiStar,
    FiX,
    FiMenu,
    ImCalculator,
    FaStar,
    FiChevronUp,
    FiChevronDown,
    FiEdit2,
    FiArrowLeft,
    FiArrowRight,
    TbInfoCircle,
    FiMoreVertical,
    FiMoreHorizontal,
    FiSend,
    FiCopy,
    FiEyeOff,
    FiAlertTriangle,
    FiSave,
    FiUser,
    IoMdSquare,
    FiUpload,
    BiLoaderAlt,
    BsArrowsFullscreen,
    TbArrowsMinimize,
    FaGlobeAmericas,
    helpIcon,
    houseIcon,
    purchaseIcon,
    buildIcon,
    brrrrIcon,
  };

  return icons[icon] ?? DefaultIcon;
};

export default function Icon({ icon, classes, ...props }) {
  // return dynamic icon component based on icon prop
  return React.createElement(getIcon(icon), { className: classes, ...props });
}
